import { Circle as CircleOriginal, type GetProps, Square as SquareOriginal, styled, View as ViewOriginal, XStack as XStackOriginal, YStack as YStackOriginal } from "tamagui";
import { shadow } from "../themes/token-shadow";
import { hairline } from "../utils";
export const variantConstants = {
  bordered: {
    true: {
      borderWidth: hairline,
      borderColor: "$strokeSecondary"
    },
    false: {}
  },
  shadow
} as const;
export const YStack = styled(YStackOriginal, {
  variants: variantConstants
});
export const XStack = styled(XStackOriginal, {
  variants: variantConstants
});
export const View = styled(ViewOriginal, {
  variants: variantConstants
});
/** @deprecated Use `View` instead */
export const Stack = View;
export const Circle = styled(CircleOriginal, {
  variants: variantConstants
});
export const Square = styled(SquareOriginal, {
  variants: variantConstants
});
export type YStackProps = GetProps<typeof YStack>;
export type XStackProps = GetProps<typeof XStack>;
export type ViewProps = GetProps<typeof View>;
/** @deprecated Use `ViewProps` instead */
export type StackProps = ViewProps;
export type CircleProps = GetProps<typeof Circle>;
export type SquareProps = GetProps<typeof Square>;